// extracted by css-extract-rspack-plugin
export default {"root":"root-jsbKaO","slot":"slot-z2gz8T","button":"button-nRl04N text-xs-semibold","slotButton":"slotButton-fq8633 text-xs-medium","invalid":"invalid-uFCNHr"};